module.exports = __webpack_public_path__ + "static/media/bg_gradient.59c2b44b.png";